(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("notifier"), require("basewidget"), require("i18n"), require("utilities"), require("lodash"), require("comparisonbarchart"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "notifier", "basewidget", "i18n", "utilities", "lodash", "comparisonbarchart"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("d3"), require("notifier"), require("basewidget"), require("i18n"), require("utilities"), require("lodash"), require("comparisonbarchart")) : factory(root["d3"], root["notifier"], root["basewidget"], root["i18n"], root["utilities"], root["_"], root["comparisonbarchart"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/